export const SESSION_COOKIE_CONFIG = {
  path: '/',
  domain: process.env.COOKIE_DOMAIN,
}

export const GEO_IP_COUNTRY_COOKIE_NAME = 'cGeoIpCountry'
